import React, { useState, useEffect, useLayoutEffect } from 'react';

async function getUserFriends() {    
    const response = await fetch('/api/get-account-friends', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function getAccountData(uuid) {
    const response = await fetch('/api/get-friend-account-data-uuid', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function getUserUUID() {
    const response = await fetch('/api/get-account-uuid', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        return user_data;
    } else {
        return false;
    }
}

async function getAccountPresence(uuid) {
    const response = await fetch('/api/get-account-status', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

function DashboardActiveHeaderDrivers({setCurrentDriver, currentDriver, setCurrentDriverUUID}) {
    const [isVisible, setIsVisible] = useState(false);
    const [drivers, setDrivers] = useState([])
    const [searchedDriverName, setSearchedDriverName] = useState("")

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleDriverChange = (value, uuid, status) => {
        if (status === "Online") {
            setCurrentDriver(value);
            setCurrentDriverUUID(uuid);
        }
    };

    const fetchFriends = async () => {
        const friends_uuid = await getUserFriends()
        var friends = []
        var you_uuid = undefined

        await Promise.all(
            friends_uuid.map(async (uuid) => {
                var data = await getAccountData(uuid)

                var presence = await getAccountPresence(uuid) === 1 ? "Online" : "Offline"

                console.log(presence)
                
                data.nome = data.name + " " + data.surname
                data.user_uuid = uuid;
                data.status = presence;

                if (data.privacy === "friends") {
                    friends.push(data)
                }
            })
        );

        you_uuid = await getUserUUID();
        friends.push({nome: "You", status: "Online", friendCode: "1", user_uuid: you_uuid})
        setDrivers(friends)
    };

    useEffect(() => {
        if (drivers.length === 1) {
            setCurrentDriver("You")
        }
    }, [drivers, setCurrentDriver])

    useLayoutEffect(() => {
        const startDrivers = async () => {
            await fetchFriends();
        };

        startDrivers()
    }, [])

    useEffect(() => {
        const interval = setInterval(async () => {
            await fetchFriends();
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex absolute left-[50%] translate-x-[-50%] items-center gap-6 z-[999]">
            <button className="flex items-center gap-3 px-4 py-2 bg-[#1a2b3c] hover:bg-[#233648] border border-[#324d67] rounded-lg transition-all" onClick={toggleVisibility}>
                <span className="material-symbols-outlined text-primary text-xl">person_search</span>

                <div className="flex flex-col items-start">
                    <span className="text-[9px] uppercase text-[#92adc9] font-bold leading-none">Select Driver</span>

                    <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-white uppercase tracking-tight">{currentDriver}</span>
                        <span className="material-symbols-outlined text-sm text-[#92adc9]">keyboard_arrow_down</span>
                    </div>
                </div>
            </button>

            <div className={`absolute top-full right-0 mt-2 w-72 bg-[#0a0c10]/95 backdrop-blur-md border border-[#324d67] rounded-lg shadow-2xl z-[100] p-1 overflow-hidden ${isVisible ? 'visible' : 'invisible'}`}>
                <div className="p-2 border-b border-[#324d67]/50 mb-1">
                    <div className="relative">
                        <span className="material-symbols-outlined absolute left-2 top-2 text-sm text-[#92adc9]">search</span>
                        <input onChange={(e) => setSearchedDriverName(e.target.value)} className="w-full bg-[#111a22] border-none rounded text-xs pl-8 focus:ring-1 focus:ring-primary h-8 text-white placeholder:text-[#324d67]" placeholder="Search pilots..." type="text" />
                    </div>
                </div>

                <div className="space-y-0.5 max-h-[300px] overflow-y-auto">
                    {drivers
                    .filter(driver => 
                        driver.nome.toLowerCase().includes(searchedDriverName.toLowerCase())
                    )
                    .map((userFriendsData) => (
                            <div 
                            key={userFriendsData.friendCode}
                            className={`${userFriendsData.nome === currentDriver ? "bg-primary/20 border-primary/30 shadow-[inset_0_0_10px_rgba(19,127,236,0.1)]" : "hover:bg-[#1a2b3c] border-transparent hover:border-[#324d67]"} ${userFriendsData.status === "Online" ? "cursor-pointer" : "cursor-not-allowed"} flex items-center justify-between p-3 border transition-colors group rounded`}
                            onClick={() => handleDriverChange(userFriendsData.nome, userFriendsData.user_uuid, userFriendsData.status)}
                            >
                                <div className="flex flex-col">
                                        <span className="text-[11px] font-bold text-white uppercase tracking-wide">{userFriendsData.nome}</span>
                                        <span className={`${userFriendsData.status === "Online" ? "text-acc-green" : "text-[#92adc9]"} text-[9px] font-bold uppercase tracking-tighter`}>{userFriendsData.status}</span>
                                </div>

                                {userFriendsData.nome === currentDriver ? (
                                    <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
                                ):(
                                    <div className={`${userFriendsData.status === "Online" ? "bg-acc-cyan shadow-[0_0_5px_rgba(0,242,255,0.5)]" : "bg-[#92adc9]"} size-1.5 rounded-full`}></div>
                                )}
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveHeaderDrivers;